export const POLLUTION = [
    'дуже добре', 'добре', 'середнє', 'погане', 'дуже погане'
];

export const COLORS_INDEX = ['#0c0', '#6c0', '#ff0', '#f90', 'red'];